export default {"src":"/trader-new/_next/static/media/Profile.80c0a879.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};